<template>
    <b-button
        variant="primary"
        @click.stop="$router.push({ name: 'Aplicacoes_Atualizar' })"
        v-if="$temAcessoView('CTRLACS-APP-03')"
        class="mr-2"
    >
        <span> <i class="fa fa-edit mr-2"></i> Atualizar</span>
    </b-button>
</template>

<script>
export default {}
</script>
